import React from 'react';
import styled from '@emotion/styled';
import type { BorderColorProps, SpaceProps, WidthProps } from 'styled-system';
import { borderColor, space, width } from 'styled-system';

import { useLocalization } from '../../providers/LocaleProvider';
import { HomeClubSectionEventPlacement } from '../../tracking/home-club';
import { Element } from '../../types/tracking';
import { Button } from '../Button';
import { HeadlineH8 } from '../Typography';

interface MembershipDiscountSkipButtonProps {
  onSkip: () => void;
  eventName?: string;
}

const StyledButton = styled(Button)<WidthProps & SpaceProps & BorderColorProps>`
  ${width};
  ${space};
  ${borderColor};
`;

export const MembershipDiscountSkipButton = ({
  onSkip,
  eventName,
}: MembershipDiscountSkipButtonProps) => {
  const { t } = useLocalization();
  const skipButtonLabel = t('h24_continue_without_hc');

  return (
    <StyledButton
      kind="secondary"
      isRounded={true}
      width={1}
      mt="sp_12"
      borderColor="sys.neutral.border.default"
      onClick={onSkip}
      tracking={{
        element: Element.Button,
        eventName,
        text: skipButtonLabel,
        placement: HomeClubSectionEventPlacement.Modal,
      }}
    >
      <HeadlineH8 color="sys.neutral.text.default">{skipButtonLabel}</HeadlineH8>
    </StyledButton>
  );
};

export default MembershipDiscountSkipButton;
